/**
 * 면적: ㎡ 와 평.
 *
 * 저장은 ㎡ 하나로 한다. 둘 다 저장하면 언젠가 서로 맞지 않는 값이 들어가고,
 * 그때 어느 쪽이 계약서에 적힌 숫자인지 알 수 없다.
 *
 * 보여줄 때는 둘 다 낸다. 등기와 계약서는 ㎡ 로 쓰지만 사람은 평으로 크기를
 * 가늠한다 -- "84㎡" 는 잘 안 그려져도 "25평" 은 그려진다.
 */

/** 1평 = 400/121 ㎡. 3.3058… 을 반올림해 두면 큰 면적에서 어긋난다. */
export const M2_PER_PYEONG = 400 / 121;

export const toPyeong = (m2) => {
    const n = Number(m2);
    return Number.isFinite(n) ? n / M2_PER_PYEONG : null;
};

export const toM2 = (pyeong) => {
    const n = Number(pyeong);
    return Number.isFinite(n) ? n * M2_PER_PYEONG : null;
};

const round = (n, digits) => {
    const p = 10 ** digits;
    return Math.round(n * p) / p;
};

/** 화면에 적는 말. "84.5㎡ (25.6평)" */
export const formatArea = (m2) => {
    const n = Number(m2);
    if (!Number.isFinite(n) || n <= 0) return '';
    return `${round(n, 2)}㎡ (${round(n / M2_PER_PYEONG, 1)}평)`;
};

/** 입력 칸에 적힌 값을 ㎡ 로. 평으로 적었으면 바꿔 준다. */
export const areaToM2 = (value, unit) => {
    if (value === '' || value === null || value === undefined) return '';
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    return unit === 'pyeong' ? round(toM2(n), 2) : round(n, 2);
};

/** ㎡ 로 저장된 값을 입력 칸이 쓰는 단위로. */
export const m2ToInput = (m2, unit) => {
    if (m2 === '' || m2 === null || m2 === undefined) return '';
    const n = Number(m2);
    if (!Number.isFinite(n)) return '';
    return unit === 'pyeong' ? round(toPyeong(n), 2) : round(n, 2);
};
